// export const REACT_APP_API_URL_STATIC = 'https://localhost:5000';
// export const REACT_APP_API_URL = 'http://localhost:5000';
export const REACT_APP_API_URL_STATIC = 'https://api.draft2.ru/';
export const REACT_APP_API_URL = 'https://api.draft2.ru/';
export const REACT_APP_LIMIT_CART_ON_PAGE = 12;